import { render, staticRenderFns } from "./DoctorForm.vue?vue&type=template&id=43c367e2&scoped=true"
import script from "./DoctorForm.vue?vue&type=script&lang=ts"
export * from "./DoctorForm.vue?vue&type=script&lang=ts"
import style0 from "./DoctorForm.vue?vue&type=style&index=0&id=43c367e2&prod&scoped=true&lang=css"
import style1 from "./DoctorForm.vue?vue&type=style&index=1&id=43c367e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c367e2",
  null
  
)

export default component.exports